var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.48C18.69 11.48 19.83 12.21 20.48 12.82L23.02 10.34C21.46 8.89 19.43 8 17 8C13.48 8 10.44 10.02 8.95996 12.96L11.87 15.22C12.6 13.05 14.62 11.48 17 11.48Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.64 17.2001C25.64 16.4601 25.58 15.9201 25.45 15.3601H17V18.7001H21.96C21.86 19.5301 21.32 20.7801 20.12 21.6201L22.96 23.8201C24.66 22.2501 25.64 19.9401 25.64 17.2001Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 18.78C11.69 18.22 11.58 17.62 11.58 17C11.58 16.38 11.69 15.78 11.87 15.22L8.96 12.96C8.35 14.18 8 15.55 8 17C8 18.45 8.35 19.82 8.96 21.04L11.88 18.78Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26C19.43 26 21.47 25.2 22.96 23.82L20.12 21.62C19.36 22.15 18.34 22.52 17 22.52C14.62 22.52 12.6 20.95 11.88 18.78L8.96997 21.04C10.45 23.98 13.48 26 17 26Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.011923744aa9faf41ee8946b8d6d731d.svg";
export { ForwardRef as ReactComponent };